import { Route, Routes } from "react-router-dom"
import { AppShell } from "./layouts/app-shell/index.js"
import { DomainPage } from "../pages/domain/index.js"
import { CatalogPage } from "../pages/catalog/index.js"
import { TenantsPage } from "../pages/tenants/index.js"
import { ClientHealthPage } from "../pages/health/index.js"
import { RunsPage } from "../pages/ops/runs/index.js"
import { CoveragePage } from "../pages/ops/coverage/index.js"
import { StaffPage } from "../pages/admin/staff.js"
import { DashboardHomePage } from "../pages/dashboards/home.js"
import { DashboardsPage } from "../pages/dashboards/index.js"
import { DashboardDetailPage } from "../pages/dashboards/detail.js"
import { LoginPage } from "../pages/login/index.js"
import { PendingPage } from "../shared/components/pending-page.js"
import { RequireAuth } from "./require-auth.js"

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireAuth />}>
      {/*
        ⚠ `showFilters` is **only for the three pages that really read the filters**: the home dashboard, the
        domain pages and dashboard detail. On any other page that row of filters would change nothing (see the comment in AppShell).
        */}
      <Route
        path="/"
        element={
          <AppShell showFilters>
            <DashboardHomePage />
          </AppShell>
        }
      />
      <Route
        path="/domain/:domainSlug"
        element={
          <AppShell showFilters>
            <DomainPage />
          </AppShell>
        }
      />
      <Route
        path="/tenants"
        element={
          <AppShell>
            <TenantsPage />
          </AppShell>
        }
      />
      <Route
        path="/tenants/health"
        element={
          <AppShell showFilters>
            <ClientHealthPage />
          </AppShell>
        }
      />
      <Route
        path="/tenants/:tenantId"
        element={
          <AppShell>
            <PendingPage
              title="Customer 360"
              stage="L1 (1-7)"
              what="Profile, collection health, the four-state status of all 90 metrics for this deployment, and its key trends."
            />
          </AppShell>
        }
      />
      <Route
        path="/dashboards"
        element={
          <AppShell>
            <DashboardsPage />
          </AppShell>
        }
      />
      <Route
        path="/dashboards/:slug"
        element={
          <AppShell showFilters>
            <DashboardDetailPage />
          </AppShell>
        }
      />
      <Route
        path="/catalog"
        element={
          <AppShell>
            <CatalogPage />
          </AppShell>
        }
      />
      <Route
        path="/ops/coverage"
        element={
          <AppShell>
            <CoveragePage />
          </AppShell>
        }
      />
      <Route
        path="/admin/staff"
        element={
          <AppShell>
            <StaffPage />
          </AppShell>
        }
      />
      <Route
        path="/ops/runs"
        element={
          <AppShell>
            <RunsPage />
          </AppShell>
        }
      />

      <Route
        path="*"
        element={
          <AppShell>
            <PendingPage title="Page not found" stage="—" what="Check the address bar — every entry in the sidebar works." />
          </AppShell>
        }
      />
      </Route>
    </Routes>
  )
}
